const question4 = {
    'question': 'Jak długo trwa proces diagnozy autyzmu?',
    'answer': 'Czas trwania procesu diagnozy autyzmu zależy od wielu czynników, w tym: wieku pacjenta czy dostępności specjalistów. Obecnie cały proces diagnostyczny wynosi od 3 tygodni do 1 miesiąca.',
}

export default question4;